import { render, staticRenderFns } from "./NymCard.vue?vue&type=template&id=1f1ccb97&"
import script from "./NymCard.vue?vue&type=script&lang=js&"
export * from "./NymCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports